import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import lambdaLogo from '../../assets/images/lt_logo.svg';
import { fetchAuditData } from '../../redux/actions/performanceAction';
import PerformaceScore from '../../components/PerformaceScore';
import PerformaceMetrics from '../../components/PerformaceMetrics';
import PerformaceByDevice from '../../components/PerformaceByDevice';
import PerformaceRuntimeSetting from '../../components/PerformaceRuntimeSetting';

const PerformacePage = () => {
  const { id } = useParams();
  const [mobile, setMobile] = useState({});
  const [desktop, setDesktop] = useState({});
  const [left, setLeft] = useState({});
  const [right, setRight] = useState({});
  const [top, setTop] = useState({});
  const [bottom, setBottom] = useState({});
  const [error, setError] = useState(false);

  const [showPerformance, setShowPerformance] = useState(false);

  useEffect(() => {
    startPolling(id);
  }, [id]);

  useEffect(() => {
    setShowPerformance(true);
  }, [left, right, top, bottom]);

  const startPolling = (id) => {
    var poll = setInterval(() => {

      const auditData = fetchAuditData(id);
      auditData
        .then((v) => {
          const { data } = v;
          if (data && data.status.toLowerCase() === "success") {

            let mobile = data?.data?.mobile?.data.categories;
            let desktop = data?.data?.desktop?.data.categories;
            mobile = { ...mobile, ...data?.data?.mobile?.analytic_response };
            desktop = { ...desktop, ...data?.data?.desktop?.analytic_response };
            // setAuditConfig();
            setDesktop(desktop);
            setMobile(mobile);
            setLeft(  data?.data?.mobile?.local_report?.left.name
              ? data?.data?.mobile?.local_report?.left
              : {});
            setRight(
              data?.data?.mobile?.local_report?.right.name
                ? data?.data?.mobile?.local_report?.right
                : {}
            );
            setTop(
              data?.data?.mobile?.local_report?.top.name
                ? data?.data?.mobile?.local_report?.top
                : {}
            );
            setBottom(
              data?.data?.mobile?.local_report?.bottom.name
                ? data?.data?.mobile?.local_report?.bottom
                : {}
            );
            clearInterval(poll);
          }
        })
        .catch((err) => {
          clearInterval(poll);
          setError(true)
        });
    }, 2000);
  };

  const checkReportError = (type) => {
    const { performance, accessibility, seo, pwa } =
      type === "mobile" ? mobile : desktop;
    const bestPractice =
      type === "mobile" ? mobile["best-practices"] : desktop["best-practices"];
    const tempIds = [
      performance.id.length > 0,
      accessibility.id.length > 0,
      seo.id.length > 0,
      pwa.id.length > 0,
      bestPractice.id.length > 0,
    ];
    return tempIds.indexOf(true) > -1;
  };

  const getAuditDataScore = (type) => {
    const { performance, accessibility, seo, pwa } =
      type === "mobile" ? mobile : desktop;
    const bestPractice =
      type === "mobile" ? mobile["best-practices"] : desktop["best-practices"];
    const tempScore = {
      performance: performance.score,
      accessibility: accessibility.score,
      seo: seo.score,
      pwa: pwa.score,
      bestPractice: bestPractice.score,
    };
    return tempScore;
  };


  return (
    <div className='performacePage'>
      <div className='performaceReport'>
        <img src={lambdaLogo} alt='lt_logo' className='pb-30' />
        <h5 className='heading text-size-30 color-indigo-900 font-weight-bold'>
          PERFORMANCE REPORT
        </h5>

        {mobile &&
        desktop &&
        Object.keys(mobile).length > 0 &&
        Object.keys(desktop).length > 0 ? (
          <>
            {checkReportError("mobile") && checkReportError("desktop") && (
              <>
                <PerformaceScore
                  desktopScore={getAuditDataScore("desktop").performance}
                  mobileScore={getAuditDataScore("mobile").performance}
                  // activeTab={activeTab}
                />
                <PerformaceMetrics
                  url={left ? left.url : "www.lambdatest.com"}
                  desktopMetrics={getAuditDataScore("desktop")}
                  mobileMetrics={getAuditDataScore("mobile")}
                  desktopLabData={
                    desktop.hasOwnProperty("lab_data") && desktop["lab_data"]
                  }
                  mobileLabData={
                    mobile.hasOwnProperty("lab_data") && mobile["lab_data"]
                  }
                  desktopOpportunities={
                    desktop.hasOwnProperty("opportunities") &&
                    desktop["opportunities"]
                  }
                  mobileOpportunities={
                    mobile.hasOwnProperty("opportunities") &&
                    mobile["opportunities"]
                  }
                  desktopDiagnostics={
                    desktop.hasOwnProperty("diagnostics") &&
                    desktop["diagnostics"]
                  }
                  mobileDiagnostics={
                    mobile.hasOwnProperty("diagnostics") &&
                    mobile["diagnostics"]
                  }
                  // activeTab={activeTab}
                />
              </>
            )}
            {showPerformance ? (
              <PerformaceByDevice
                left={left}
                right={right}
                top={top}
                bottom={bottom}
                showPerformance={showPerformance}
                setShowPerformance={setShowPerformance}
              />
            ) : (
              ""
            )}
            <PerformaceRuntimeSetting
              url={left ? left.url : "www.lambdatest.com"}
              time={left ? left.time : "time"}
            />
          </>
        ) : (
          <div className='position-relative'>
            <div className='position-absolute w-100 text-center mt-5'>
              {/* <Loader /> */}
              <p className='mt-3 text-size-16'>
                {error ? 'Unable to fetch the report!' : 'Hang on, we are fetching your report 🚀.'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default PerformacePage;
